import { BASVURU_RUHSAT_TIPI_SORGULA } from "../constants/requestUrls";
import { getRequest } from "../request";

const parentBasvuruRuhsatTipiSorgula = (parentObjectId) => {
    return getRequest({ url: BASVURU_RUHSAT_TIPI_SORGULA + "?parentObjectId=" + parentObjectId });
}

export default parentBasvuruRuhsatTipiSorgula;